import React from "react";
import Divider from "@mui/material/Divider";

import {useUserContext} from "../../contexts/UserContext";
import classnames from "classnames";

import {useUIContext} from "../../contexts/UIContext";
import {AppNavLinks} from "./AppNavlinks";
import Typography from "@mui/material/Typography";

import { ReactComponent as LogoSVG } from '../../assets/svgs/logo.svg'
import Stack from "@mui/material/Stack";

export const AppSidebarNav = () => {
    const { profileState } = useUserContext()
    const { uiState, toggleSideNavDrawer } = useUIContext()
    const {sideDrawerOpen, sideNavDrawerWidth, sideDrawerPinned} = uiState

    return (
        <div
            style={{ width: `${sideNavDrawerWidth}px` }}
            className={classnames('AppSidebarNav__container', {
                hidden: !sideDrawerOpen,
            })}
            onMouseEnter={() => toggleSideNavDrawer(true)}
            onMouseLeave={() => toggleSideNavDrawer(false)}
        >
            <div className={'AppSidebarNav-info'}>
                <div
                    className={classnames('arrow-container', {
                        pinned: sideDrawerPinned
                    })}
                    onClick={toggleSideNavDrawer}
                >
                    {/*{ sideDrawerOpen ? <KeyboardArrowLeftIcon/> : <KeyboardArrowRightIcon/>}*/}
                </div>
                <br></br>
                <Typography
                    gutterBottom
                    variant="subtitle1"
                    component="h5"
                    className={'hide'}
                >
                    <Stack
                        flexDirection={'column'}
                        justifyContent="center"
                        alignItems={'center'}
                    >
                        <LogoSVG
                            style={{
                                width: !sideDrawerOpen ? '50px' : '150px',
                                // marginBottom: !sideDrawerOpen ? '5px' : '0px',
                            }}
                            className={'sidebar-logo'}
                        />
                        <span>{profileState.account_name}</span>
                    </Stack>
                </Typography>
            </div>
            {/*<LogoSVG style={{ width: '150px'}}/>*/}
            <Divider className={'divider'} />
            <AppNavLinks />
        </div>
    )
}